(function () {
  if (window.__priceCountdown) return;
  window.__priceCountdown = true;
  var p = function (n) { return String(n).padStart(2, '0'); };
  function tick() {
    document.querySelectorAll('.price-countdown').forEach(function (el) {
      var end = new Date(el.getAttribute('data-end'));
      var s = Math.max(0, Math.floor((end - new Date()) / 1000));
      var d = Math.floor(s / 86400);
      el.querySelector('.price-countdown__time').textContent =
        (d > 0 ? d + 'j ' : '') + p(Math.floor((s % 86400) / 3600)) + ':' + p(Math.floor((s % 3600) / 60)) + ':' + p(s % 60);
      el.style.display = s > 0 ? 'inline' : 'none';
    });
  }
  tick();
  setInterval(tick, 1000);
})();